<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- Structure form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código Actividad *"
          label-for="codigo"
          description="Escriba el código de la actividad"
        >
          <b-form-input
            id="codigo"
            v-model="structure.id_actividad"
            type="text"
            required
            placeholder="Código Actividad"
          ></b-form-input>
        </b-form-group>
        <!-- codigo -->
        <b-form-group
          label="Código Sector *"
          label-for="codigo"
          description="Escriba el código del sector"
        >
          <b-form-input
            id="codigo"
            v-model="structure.id_sector"
            type="text"
            required
            placeholder="Código Sector"
          ></b-form-input>
        </b-form-group>
        <!-- codigo -->
        <b-form-group
          label="Código Mercado *"
          label-for="codigo"
          description="Escriba el código del mercado"
        >
          <b-select v-model="structure.id_mercado">
            <b-select-option
              v-for="item in mercados"
              :key="item.id_mercado"
              :value="item.id_mercado"
              >{{ item.descripcion }}</b-select-option
            >
          </b-select>
        </b-form-group>

        <!-- literal -->
        <b-form-group
          label="Literal Actividad *"
          label-for="literal"
          description="Escriba el Literal Actividad"
        >
          <b-form-input
            id="literal"
            v-model="structure.descripcion"
            type="text"
            required
            placeholder="Literal Actividad"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_STRUCTURE,
  EDIT_STRUCTURE
} from "@/core/services/store/structures.module";
import ApiService from "../../../core/services/api.service";

export default {
  name: "structure-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: false,
      mercados: [],
      structure: {
        id_actividad: null,
        id_sector: null,
        id_mercado: null,
        description: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar actividad" : "Nueva actividad";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    this.loading = true;
    if (this.isEdit) {
      const resp = await ApiService.get(
        `dic_actividades?id_actividad=${this.$route.params.id}`
      );
      this.structure = resp.data.result[0];
      const resp2 = await ApiService.get(
        `dic_mercados?id_mercado=${this.structure.id_mercado}`
      );
      this.mercados = resp2.data.result;
    } else {
      const resp3 = await ApiService.get(`dic_mercados?limit=1000000000`);
      this.mercados = resp3.data.result;
    }
    this.loading = false;
  },
  methods: {
    cancel() {
      this.$router.push("/structure");
    },
    onSubmit() {
      if (this.isEdit) {
        this.$store.dispatch(EDIT_STRUCTURE, this.structure);
      } else {
        this.$store.dispatch(ADD_STRUCTURE, this.structure);
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
